import { css, Theme } from '@emotion/react'

export const countValue = css`
  text-align: right;
`

export const categoriesWrapper = css`
  flex: 1;
`

export const categoriesTable = css`
  .table-header .table-cell {
    font-weight: 700;
  }

  .table-row {
    padding: 5px 12px;
  }
`

export const videosWrapper = (theme: Theme) => css`
  flex: 1;
  border-radius: 20px;
  background: ${theme.backgrounds.backgroundThree};
  padding: 14px;
`

export const addVideoButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.5)};
  width: 100%;
`

export const videoCategoryTable = (theme: Theme) => css`
  .table-header {
    background: ${theme.backgrounds.backgroundFour};

    .table-cell {
      font-weight: 700;
    }
  }

  .table-row {
    padding: 5px 12px;
  }
`

export const popper = css`
  z-index: 2;
`
